import { inject } from '@angular/core';
import {
  EMessageType,
  FELLOW_TRAVELER_SCHEMA,
  FELLOW_TRAVELERS_SCHEMA,
  IFellowTravelerDto,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';
import { IDeleteGateway, IListGateway, ISaveGateway } from '../gateways';

export class FellowTravelerGateway
  implements
    IListGateway<never, IApiResponse<IFellowTravelerDto[]>>,
    ISaveGateway<IFellowTravelerDto, IApiResponse<IFellowTravelerDto>>,
    IDeleteGateway<string, IApiResponse<IFellowTravelerDto[]>>
{
  private readonly configService: AppConfigService = inject(AppConfigService);

  private readonly getAllRestCallBuilder: RestCallBuilder<
    never,
    IFellowTravelerDto[]
  > = new RestCallBuilder<never, IFellowTravelerDto[]>([]);

  private readonly saveRestCallBuilder: RestCallBuilder<
    IFellowTravelerDto,
    IFellowTravelerDto
  > = new RestCallBuilder<IFellowTravelerDto, IFellowTravelerDto>({
    id: '',
    salutation: null,
    firstName: '',
    lastName: '',
    dateOfBirth: null,
  });

  private readonly updateRestCallBuilder: RestCallBuilder<
    IFellowTravelerDto,
    IFellowTravelerDto
  > = new RestCallBuilder<IFellowTravelerDto, IFellowTravelerDto>({
    id: '',
    salutation: null,
    firstName: '',
    lastName: '',
    dateOfBirth: null,
  });

  private readonly deleteRestCallBuilder: RestCallBuilder<
    never,
    IFellowTravelerDto[]
  > = new RestCallBuilder<never, IFellowTravelerDto[]>([]);

  list(): Observable<IApiResponse<IFellowTravelerDto[]>> {
    return this.getAllRestCallBuilder
      .getExternal(
        `${this.configService.get().general.userServiceUrl}/fellow-travelers`
      )
      .validate(
        API_RESPONSE_SCHEMA(FELLOW_TRAVELERS_SCHEMA),
        'FellowTraveler.list'
      )
      .handleMessages([EMessageType.ERROR])
      .build();
  }
  save(
    query: IFellowTravelerDto
  ): Observable<IApiResponse<IFellowTravelerDto>> {
    return this.saveRestCallBuilder
      .postExternal(
        `${this.configService.get().general.userServiceUrl}/fellow-travelers`,
        query
      )
      .validate(
        API_RESPONSE_SCHEMA(FELLOW_TRAVELER_SCHEMA),
        'FellowTraveler.save'
      )
      .handleMessages()
      .build();
  }

  update(
    fellowTravelerId: string,
    query: IFellowTravelerDto
  ): Observable<IApiResponse<IFellowTravelerDto>> {
    return this.updateRestCallBuilder
      .putExternal(
        `${this.configService.get().general.userServiceUrl}/fellow-travelers/${fellowTravelerId}`,
        query
      )
      .validate(
        API_RESPONSE_SCHEMA(FELLOW_TRAVELER_SCHEMA),
        'FellowTraveler.update'
      )
      .handleMessages()
      .build();
  }

  delete(
    fellowTravelerId: string
  ): Observable<IApiResponse<IFellowTravelerDto[]>> {
    return this.deleteRestCallBuilder
      .deleteExternal(
        `${this.configService.get().general.userServiceUrl}/fellow-travelers/${fellowTravelerId}`
      )
      .validate(
        API_RESPONSE_SCHEMA(FELLOW_TRAVELERS_SCHEMA),
        'FellowTraveler.delete'
      )
      .handleMessages()
      .build();
  }
}
